export default __webpack_public_path__ + "static/media/doll.74f0034e.svg";